/** @jsxImportSource @emotion/react */
import React from 'react'
import { teamSectionHeaderStyle, teamSectionHeaderTextStyle } from '../styles'

export interface TeamSectionHeaderProps {
  teamName: string
}

const TeamSectionHeader: React.FC<TeamSectionHeaderProps> = ({ teamName }) => {
  return (
    <div css={teamSectionHeaderStyle}>
      <p css={teamSectionHeaderTextStyle}>{teamName}</p>
    </div>
  )
}

export default React.memo(TeamSectionHeader)
